// assets/bb-swiper.js
// O único inicializador de Swiper do tema (Lote 5, item 5.5). Antes disto havia 8
// `new Swiper` inline, cada um com a sua cópia de espera, escopo e paginação.
//
// Contrato: elemento .swiper com data-swiper-config='<JSON de opções do Swiper 11>'.
// - seletores de pagination/navigation/scrollbar são resolvidos DENTRO do carrossel
//   ([data-swiper-scope] mais próximo, senão o pai do .swiper). É o que impede dois
//   carrosséis na mesma página de disputarem o mesmo ".swiper-pagination" -- o
//   snippet swiper-settings emitia exatamente esse seletor global (o snippet foi apagado). Se o seletor não
//   casar dentro do escopo, o resolver devolve null (não a string crua) e avisa no
//   console -- string crua faria o Swiper resolver contra o document, e é exatamente
//   essa disputa entre carrosséis que este arquivo existe para impedir.
// - depois de instanciar, dispara 'bb:swiper' no elemento, com detail.swiper. Quem
//   precisa da instância (dots próprios, autoplay condicional) ouve o evento.
//
// Não há espera pelo Swiper: layout/theme.liquid:104 carrega o bundle com `defer` no
// <head> e scripts `defer` executam em ordem de documento -- o bundle já rodou quando
// este arquivo, referenciado no corpo, roda. O setInterval de 6s do achado #16 era
// código morto.
(function () {
  function resolver(escopo, el, valor) {
    if (typeof valor !== 'string') return valor;
    var achado = escopo.querySelector(valor);
    if (!achado) {
      console.warn('bb-swiper: seletor "' + valor + '" não encontrado no escopo do carrossel', el);
      return null;
    }
    return achado;
  }

  function iniciar(el) {
    if (el.swiper || el.dataset.bbSwiper === 'pronto') return;
    if (typeof window.Swiper !== 'function') {
      console.error('bb-swiper: Swiper não carregou (CDN fora do ar?)', el);
      return;
    }

    var opts;
    try {
      opts = JSON.parse(el.getAttribute('data-swiper-config') || '{}');
    } catch (e) {
      console.error('bb-swiper: data-swiper-config inválido', el, e);
      return;
    }

    var escopo = el.closest('[data-swiper-scope]') || el.parentElement || document;
    if (opts.pagination && opts.pagination.el) opts.pagination.el = resolver(escopo, el, opts.pagination.el);
    if (opts.navigation) {
      if (opts.navigation.nextEl) opts.navigation.nextEl = resolver(escopo, el, opts.navigation.nextEl);
      if (opts.navigation.prevEl) opts.navigation.prevEl = resolver(escopo, el, opts.navigation.prevEl);
    }
    if (opts.scrollbar && opts.scrollbar.el) opts.scrollbar.el = resolver(escopo, el, opts.scrollbar.el);

    // Isolado por carrossel: uma exceção aqui não pode derrubar a varredura inteira
    // (varias seções de carrossel na mesma página, ex. a home). A marca de pronto só
    // é gravada depois do sucesso -- uma falha não impede nova tentativa futura.
    try {
      var swiper = new window.Swiper(el, opts);
      el.dataset.bbSwiper = 'pronto';
      el.dispatchEvent(new CustomEvent('bb:swiper', { bubbles: true, detail: { swiper: swiper } }));
    } catch (e) {
      console.error('bb-swiper: falha ao inicializar', el, e);
    }
  }

  function varrer(raiz) {
    raiz = raiz || document;
    if (raiz.matches && raiz.matches('.swiper[data-swiper-config]')) iniciar(raiz);
    raiz.querySelectorAll('.swiper[data-swiper-config]').forEach(iniciar);
  }

  // Idempotência por página: um script clássico com o mesmo src roda uma vez por
  // <script src>, não uma vez por página -- com N seções de carrossel isso é N
  // execuções desta IIFE. Sem a guarda abaixo, cada execução registraria seu próprio
  // listener de shopify:section:load (N listeners, N varreduras por seção recarregada
  // no editor de temas). Varrer de novo é inofensivo (a marca de pronto em cada
  // elemento evita dupla inicialização); registrar o listener de novo não é.
  var primeiraExecucao = !window.bbSwiper;
  window.bbSwiper = window.bbSwiper || { varrer: varrer };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      varrer(document);
    });
  } else {
    varrer(document);
  }

  if (primeiraExecucao) {
    // Editor de temas: seção recarregada por AJAX não passa por DOMContentLoaded.
    document.addEventListener('shopify:section:load', function (e) {
      varrer(e.target);
    });
  }
})();
